import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { getStorageItem, setStorageItem } from '../../../utils/Storage';
import { HOURS_IN_DAY } from '../../../utils/TimeFormatter';
import Accident from './Accident';
import AccidentV1 from './AccidentV1';
import { AccidentPageVersion } from './Defs';

const AccidentPageComponent: React.FC = () => {
    const chosenPageVersion = getStorageItem('OE-accident-page-version') as AccidentPageVersion;
    const defaultVersion = chosenPageVersion ? chosenPageVersion : 'v1';
    const [pageVersion, setPageVersion] = useState<AccidentPageVersion>(defaultVersion || 'v0');
    const history = useHistory();

    const handlePageVersionChange = (version: AccidentPageVersion) => {
        setPageVersion(version);
        setStorageItem('OE-accident-page-version', version, 7 * HOURS_IN_DAY);
        history.push({
            search: '',
        });
    };

    return pageVersion === 'v1' ? (
        <AccidentV1 handlePageVersionChange={handlePageVersionChange} />
    ) : (
        <Accident handlePageVersionChange={handlePageVersionChange} />
    );
};

export default AccidentPageComponent;
